import { Firebase } from "../../src/utils/firebase-utility";
import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/:type/:downloadId",
      name: "ビューワ",
      meta: { isLoginedOnly: false, isAnonymousOnly: false, showNavigationMenu: false },
      component: () => import("./views/viewer-view.vue"),
      props: true,
    },
  ],
});

export default router;
